export enum UserRole{
    CompanyAdmin= 1,
    ROLE_SC_ADMIN= 1,
    ROLE_SC_TEACHER= 2, //For Staff and Teacher both
    ROLE_SC_PARENT= 3,
    ROLE_SC_POWER_ADMIN= 4,
    ROLE_SC_SUBJECT_TEACHER= 5,
    ROLE_SC_INSTRUCTOR= 7,
    ROLE_SC_STUDENT= 20,
    ROLE_SUPER_ADMIN= 99
}